import React from 'react';
import { StyledButton, StyledContainer, StyledInput, StyledLabel, StyledOuterContainer, StyledIcon, StyledTagButton, StyledText } from './index.styles.js';
import {} from '../icon/icon-names.generated.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { Popover } from '../popover/index.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Tag = ({ id, label, variant, onClick, icon, className, size, popover, name, defaultChecked, onChange, checked, value, disabled, margin, ...rest }) => {
    const resolvedSize = size ?? 'md';
    const iconSize = 'xs';
    if (variant === 'read-only' || variant === 'encourage') {
        return (React.createElement(StyledContainer, { size: resolvedSize, className: className, variant: variant, margin: margin, ...pickA11yProps(rest), ...pickDataProps(rest) },
            icon && React.createElement(StyledIcon, { size: iconSize, name: icon }),
            React.createElement(StyledText, null, label)));
    }
    if (variant === 'removable') {
        return (React.createElement(StyledContainer, { size: resolvedSize, className: className, variant: variant, margin: margin, ...pickDataProps(rest) },
            React.createElement(StyledText, null, label),
            React.createElement(StyledButton, { onClick: onClick, ...pickA11yProps(rest) },
                React.createElement(StyledIcon, { size: iconSize, name: "cancel" }))));
    }
    if (variant === 'offer') {
        const icon = 'special-offer';
        if (popover) {
            return (React.createElement(StyledOuterContainer, { size: resolvedSize, ...pickA11yProps(rest), ...pickDataProps(rest) },
                React.createElement(StyledContainer, { variant: variant, size: resolvedSize },
                    React.createElement(StyledIcon, { size: iconSize, name: icon }),
                    React.createElement(StyledText, null, label)),
                React.createElement(Popover, { alignment: popover.alignment, withTip: popover.withTip, open: popover.open, onClose: popover.onClose, content: popover.content, id: popover.id, triggerElement: React.createElement(StyledButton, { onClick: popover.onTriggerClick, "aria-label": popover.triggerAriaLabel },
                        React.createElement(StyledIcon, { name: "info-circle", size: iconSize })) })));
        }
        return (React.createElement(StyledContainer, { variant: variant, ...pickA11yProps(rest), ...pickDataProps(rest) },
            React.createElement(StyledIcon, { size: iconSize, name: icon }),
            React.createElement(StyledText, null, label)));
    }
    if (variant === 'clickable') {
        return (React.createElement(StyledTagButton, { type: "button", onClick: onClick, className: className, disabled: disabled, size: resolvedSize, margin: margin, ...pickA11yProps(rest), ...pickDataProps(rest) },
            icon && React.createElement(StyledIcon, { size: iconSize, name: icon }),
            React.createElement(StyledText, null, label)));
    }
    const getIcon = () => {
        if (icon) {
            return React.createElement(StyledIcon, { size: iconSize, name: checked ? 'select' : icon });
        }
        if (checked) {
            return React.createElement(StyledIcon, { size: iconSize, name: 'select' });
        }
        return;
    };
    return (React.createElement(StyledLabel, { className: className, ...pickDataProps(rest), margin: margin },
        React.createElement(StyledContainer, { variant: variant, size: resolvedSize, "$disabled": disabled },
            React.createElement(StyledInput, { value: value, type: "checkbox", name: name, defaultChecked: defaultChecked, onChange: onChange, onClick: onClick, checked: checked, disabled: disabled, id: id, ...pickA11yProps(rest) }),
            getIcon(),
            React.createElement(StyledText, null, label))));
};
//# sourceMappingURL=index.js.map